<template>
  <div class="bg">
    <div class="content">
      <el-form :model="detailInfo" label-width="auto" label-position="left">
        <el-card>
          <!-- <el-form-item label="所属企业：">
                <el-popover
                  trigger="click"
                  :content="detailInfo.data1"
                  placement="top-start"
                >
                  <el-input
                    slot="reference"
                    v-model="detailInfo.data1"
                    size="mini"
                    clearable
                  />
                </el-popover>
                <p><i>(点击内容显示全部信息)</i></p>
              </el-form-item> -->
          <el-form-item label="所属项目：">
            <span>
              {{ project }}
            </span>
          </el-form-item>
          <el-form-item label="所属单位：">
            <span>
              {{ unit }}
            </span>
          </el-form-item>
          <el-form-item label="班组名称：">
            <span>
              {{ detailInfo.name }}
            </span>
          </el-form-item>
          <el-form-item label="组长姓名：">
            <span>{{ detailInfo.groupLeaderName }}</span>
          </el-form-item>
          <el-form-item label="证件类型：">
            <span>{{ idType }}</span>
          </el-form-item>
          <el-form-item label="证件号码：">
            <span>{{ detailInfo.idCardNumber }}</span>
          </el-form-item>
          <el-form-item label="联系电话：">
            <span>{{ detailInfo.groupLeaderPhone }}</span>
          </el-form-item>
          <el-form-item label="进场状态：">
            <span>
              {{ status }}
            </span>
          </el-form-item>
          <el-form-item label="进场日期：">
            <span>{{ detailInfo.entryTime }}</span>
          </el-form-item>
          <el-form-item label="退场日期：">
            <span>
              {{ detailInfo.exitTime }}
            </span>
          </el-form-item>
          <el-form-item label="备注信息：">
            <span v-if="detailInfo.remark == ''">无</span>
            <span v-else>
              {{ detailInfo.remark }}
            </span>
          </el-form-item>
        </el-card>
      </el-form>
    </div>
  </div>
</template>
<script>
import { postDictCode } from "@/api/dict";
import { postTeamDetail } from "@/api/app/team";
import { postListUnit } from "@/api/app/unit";
import { postProjectId } from "@/api/app/project";
export default {
  data() {
    return {
      project: "",
      unit: "",
      idType: "",
      status: "",
      detailInfo: {},
    };
  },
  created() {
    this.detail();
  },
  methods: {
    detail() {
      // 所属项目
      postProjectId(this.$store.state.app.projectId).then((a) => {
        this.project = a.data.name;
      });
      // 通过列表id获取单位详细信息
      postTeamDetail(this.$store.state.app.itemId).then((b) => {
        this.detailInfo = b.data;
        // 所属参建单位
        postListUnit(this.$store.state.app.projectId).then((c) => {
          c.data.find((item) => {
            if (item.id == b.data.unitId) {
              this.unit = item.title;
            }
          });
        });
        // 证件类型
        postDictCode("certificate_type").then((d) => {
          d.data.find((item) => {
            if (item.value == b.data.idType) {
              this.idType = item.label;
            }
          });
        });
        this.$store.state.app.dict.find((item) => {
          if (item.value == b.data.status) {
            this.status = item.label;
          }
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  margin-bottom: 50px;
  padding: 10px;
  min-height: 100vh;

  background-color: #f0f0f0;
}
.content {
  .el-form-item {
    margin: 0px;
    font-size: 14px;
  }
  p {
    i {
      font-size: 12px;
    }
  }
  .img {
    img {
      width: 150px;
      height: 100%;
    }
  }
  /deep/ .el-input__inner {
    border: unset;
    padding: 0;
  }
}
</style>
